import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import https from "https";
import axios from "axios";
import log from "../utils/log";
import metaData from "../data/metaData";
import c from "../utils/common";

//
import useAuthStore from "../states/useAuth";

const useReferral = () => {
  const { auth, user } = useAuthStore();

  const createReferral = async (data) => {
    //prepare body data
    data.companyId = user.companyId;
    //
    let res = await axios.post(metaData.serverURL + "referral", data, {
      headers: { Authorization: auth.jwt },
      httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
    });
    return res.data;
  };

  const updateReferral = async (id, data) => {
    const transformUndefinedToNull = (obj) => {
      const newObj = { ...obj };
    
      // Iterate over all the keys in the object
      Object.keys(newObj).forEach(key => {
        // If the value is undefined, replace it with null
        if (newObj[key] === undefined) {
          newObj[key] = null;
        }
      });
    
      return newObj;
    };
    data = transformUndefinedToNull(data);

    let res = await axios.patch(metaData.serverURL + "referral", data, {
      params: { id: id }, // Pass the request ID as a query parameter if needed
      headers: { Authorization: auth.jwt },
      httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
    });
    return res.data;
  };

  return { createReferral, updateReferral };
};

export default useReferral;
